import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailer_mobile-footer_mweb_desktopapp_store_badge-click';
/**
 * Event that happens when user clicks on app store badge
 */
export function trackRetailerMobileFooterMwebDesktopappStoreBadgeClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
